module.exports = __webpack_public_path__ + "static/media/fluid-loader.4979b472.gif";